<div class="car-page">
    <div class="car-panel grp-decorated-panel">

        <div class="car-panel__header grp-panel-header" style="justify-content: space-between;">
            <div class="flex items-center">
                <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="22" height="22"
                    style="margin-right: 10px; color: var(--brand-blue);">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                </svg>
                <span class="grp-title-text">Gestion Des Comptes</span>
            </div>

            <button class="grp-fancy-btn settings-btn-save flex items-center gap-2" (click)="displayModal = true">
                Ajouter un compte <i class="fas fa-plus"></i>
            </button>
        </div>

        <div class="car-panel__body settings-padding">
            <div class="flex flex-col gap-6">

                <div class="flex items-center w-full md:w-1/3 relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <i class="fas fa-search text-gray-400"></i>
                    </div>
                    <input type="text" placeholder="Rechercher un compte..." [(ngModel)]="filter"
                        name="account_search_filter" class="grp-fancy-input"
                        style="padding-left: 2.5rem; padding-right: 2.5rem;" />
                    <button *ngIf="filter" (click)="initFilter()"
                        class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <div class="shadow-sm overflow-hidden rounded-xl border border-gray-200">
                    <div class="overflow-x-auto styleScroll max-h-[72vh]">
                        <table class="w-full bg-white text-left border-collapse">
                            <thead>
                                <tr
                                    class="bg-gray-50 border-b border-gray-200 text-gray-500 uppercase text-xs font-bold tracking-wider">
                                    <th class="py-4 px-6">E-mail</th>
                                    <th class="py-4 px-6">Code Client</th>
                                    <th class="py-4 px-6">Nom d'utilisateur</th>
                                    <th class="py-4 px-6 text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100">
                                <ng-container
                                    *ngFor="let item of listCompteUtilisateur | filterPerAnykey : filter; index as i">
                                    <tr class="hover:bg-blue-50/50 transition-colors duration-150 group cursor-pointer"
                                        (dblclick)="openMenuWithUserInfo(item)">

                                        <td class="py-3.5 px-6">
                                            <div class="flex items-center gap-3">
                                                <div
                                                    class="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-xs font-bold shrink-0">
                                                    {{ item.Email?.charAt(0)?.toUpperCase() }}
                                                </div>
                                                <span
                                                    class="text-sm font-medium text-gray-900 group-hover:text-blue-700 transition-colors">
                                                    {{ item.Email }}
                                                </span>
                                            </div>
                                        </td>

                                        <td class="py-3.5 px-6">
                                            <span class="text-sm text-gray-500 font-mono bg-gray-100 px-2 py-1 rounded">
                                                {{ item.Tiers_code || '-' }}
                                            </span>
                                        </td>

                                        <td class="py-3.5 px-6">
                                            <span
                                                class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-100">
                                                {{ item.UserName }}
                                            </span>
                                        </td>

                                        <td class="py-3.5 px-6 text-right">
                                            <div
                                                class="inline-flex rounded-md shadow-sm opacity-0 group-hover:opacity-100 transition-opacity">
                                                <button (click)="openModal(item)"
                                                    class="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-l-md hover:bg-gray-50 hover:text-blue-600 focus:z-10 focus:ring-2 focus:ring-blue-500">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button (click)="deleteCompte(item.Id)"
                                                    class="px-3 py-1.5 text-sm font-medium text-red-600 bg-white border border-gray-200 border-l-0 rounded-r-md hover:bg-red-50 hover:text-red-700 focus:z-10 focus:ring-2 focus:ring-red-500">
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>

                                <tr *ngIf="!listCompteUtilisateur || listCompteUtilisateur.length == 0">
                                    <td colspan="4" class="py-20 text-center">
                                        <div class="flex flex-col items-center justify-center gap-4">
                                            <div class="spinner-circle spinner-circle--large"></div>
                                            <span class="text-sm text-gray-500 font-medium">Chargement des
                                                comptes...</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="displayModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-0">
    <!-- Backdrop with softer blur and smoother transition -->
    <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" (click)="closeModal()"></div>

    <!-- Modal Card -->
    <div
        class="relative bg-white rounded-2xl shadow-2xl ring-1 ring-black/5 w-full max-w-lg flex flex-col overflow-hidden transform transition-all">

        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-white">
            <h3 class="text-xl font-semibold text-gray-800 flex items-center gap-2.5">
                <div class="p-2 bg-blue-50 text-blue-600 rounded-lg">
                    <i class="fas fa-user-edit" *ngIf="isModifying"></i>
                    <i class="fas fa-user-plus" *ngIf="!isModifying"></i>
                </div>
                {{isModifying ? 'Modifier le compte' : 'Créer un compte'}}
            </h3>
            <button (click)="closeModal()"
                class="text-gray-400 hover:text-gray-700 bg-gray-50 hover:bg-gray-100 transition-colors rounded-full p-2 focus:outline-none focus:ring-2 focus:ring-gray-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="px-6 py-6 space-y-5 bg-slate-50/30">

            <!-- Username -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1.5" for="acc_username">Nom d'utilisateur <span
                        class="text-red-500">*</span></label>
                <div class="relative">
                    <i class="fas fa-user absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"></i>
                    <input id="acc_username" name="acc_username" type="text"
                        class="w-full pl-10 pr-4 py-2.5 text-sm text-gray-900 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all shadow-sm placeholder-gray-400"
                        placeholder="Ex: jean.dupont" [(ngModel)]="user.username" />
                </div>
            </div>

            <!-- Email -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1.5" for="acc_email">Email <span
                        class="text-red-500">*</span></label>
                <div class="relative">
                    <i class="fas fa-envelope absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"
                        [ngClass]="isEmailValid(user.email) ? 'text-green-500' : 'text-gray-400'"></i>
                    <input id="acc_email" name="acc_email" type="email"
                        class="w-full pl-10 pr-4 py-2.5 text-sm text-gray-900 bg-white border rounded-lg focus:outline-none focus:ring-4 transition-all shadow-sm placeholder-gray-400"
                        [ngClass]="isEmailValid(user.email) ? 'border-green-500 focus:border-green-500 focus:ring-green-500/10' : 'border-gray-200 focus:border-blue-500 focus:ring-blue-500/10'"
                        placeholder="exemple@domaine.com" [(ngModel)]="user.email" (focus)="focusEmail = true" />
                </div>
            </div>

            <!-- Client Code -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1.5" for="acc_tiers_code">Code Client <span
                        class="text-red-500">*</span></label>
                <div class="relative">
                    <i class="fas fa-building absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"></i>
                    <select id="acc_tiers_code" name="acc_tiers_code"
                        class="w-full pl-10 pr-10 py-2.5 text-sm text-gray-900 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all shadow-sm appearance-none"
                        [(ngModel)]="user.Tiers_code">
                        <option value="" disabled selected>Sélectionnez un client</option>
                        <option *ngFor="let tier of tiers" [value]="tier.Tiers_code">
                            {{tier.Tiers_code}} | {{ tier.Tiers_RS }}
                        </option>
                    </select>
                    <!-- Custom Select Arrow -->
                    <div class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none text-gray-500">
                        <i class="fas fa-chevron-down text-xs"></i>
                    </div>
                </div>
            </div>

            <!-- Passwords (Creation Only) -->
            <ng-container *ngIf="!isModifying">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-5">

                    <!-- Password -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1.5" for="acc_password">Mot de passe
                            <span class="text-red-500">*</span></label>
                        <div class="relative">
                            <i class="fas fa-lock absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"></i>
                            <input id="acc_password" name="acc_password" [type]="showPWD ? 'text' : 'password'"
                                class="w-full pl-10 pr-10 py-2.5 text-sm text-gray-900 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all shadow-sm placeholder-gray-400"
                                placeholder="••••••••" [(ngModel)]="user.password" />
                            <button type="button"
                                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 focus:outline-none"
                                (click)="showPWD = !showPWD">
                                <i class="fas" [ngClass]="showPWD ? 'fa-eye' : 'fa-eye-slash'"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Confirm Password -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1.5"
                            for="acc_confirm_password">Confirmer MDP <span class="text-red-500">*</span></label>
                        <div class="relative">
                            <i class="fas fa-check-circle absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"
                                [ngClass]="verifierConfirmPassword() ? 'text-green-500' : 'text-gray-400'"></i>
                            <input id="acc_confirm_password" name="acc_confirm_password"
                                [type]="showConfPWD ? 'text' : 'password'"
                                class="w-full pl-10 pr-10 py-2.5 text-sm text-gray-900 bg-white border rounded-lg focus:outline-none focus:ring-4 transition-all shadow-sm placeholder-gray-400"
                                [ngClass]="verifierConfirmPassword() ? 'border-green-500 focus:border-green-500 focus:ring-green-500/10' : 'border-gray-200 focus:border-blue-500 focus:ring-blue-500/10'"
                                placeholder="••••••••" [(ngModel)]="user.confirmpassword" />
                            <button type="button"
                                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 focus:outline-none"
                                (click)="showConfPWD = !showConfPWD">
                                <i class="fas" [ngClass]="showConfPWD ? 'fa-eye' : 'fa-eye-slash'"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </ng-container>

        </div>

        <!-- Footer Actions -->
        <div class="px-6 py-4 bg-gray-50/80 border-t border-gray-100 flex items-center justify-end gap-3">
            <button type="button"
                class="px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100 transition-all"
                (click)="closeModal()" [disabled]="isSaving">
                Annuler
            </button>

            <button
                class="px-5 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-500/30 transition-all shadow-sm flex items-center justify-center min-w-[140px] disabled:opacity-70 disabled:cursor-not-allowed"
                (click)="handleSubmit()" [disabled]="isSaving">

                <ng-container *ngIf="isSaving">
                    <!-- Standard Tailwind Spinner -->
                    <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                        </circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                    Enregistrement...
                </ng-container>

                <ng-container *ngIf="!isSaving">
                    <i class="fas fa-save mr-2"></i> Enregistrer
                </ng-container>
            </button>
        </div>

    </div>
</div>